import { ComponentType } from 'react'
import { useTranslation } from 'react-i18next'

import { TreatmentSpent } from 'app/audiences/types'
import { PagedTableProps } from 'app/common/presentation'
import { formatCurrency } from 'app/common/presentation/format'

import { Table, TableProps } from 'components'

interface SpentsTableProps extends Omit<PagedTableProps<TreatmentSpent>, 'columns' | 'renderRow'> {
  TableComponent?: ComponentType<TableProps<TreatmentSpent>>
}

const SpentsTable = ({ TableComponent = Table.Table, ...tableProps }: SpentsTableProps) => {
  const { t } = useTranslation('audiences')

  return (
    <TableComponent
      columns={[t('details.overview.columns.treatments'), t('details.overview.columns.spent')]}
      renderRow={(treatmentSpent, index) => (
        <Table.Row key={index}>
          <Table.Cell>{treatmentSpent.name}</Table.Cell>
          <Table.Cell>{formatCurrency(treatmentSpent.spent)}</Table.Cell>
        </Table.Row>
      )}
      {...tableProps}
    />
  )
}

export default SpentsTable
